var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"pageLayout",attrs:{"view":"hHh lpr lfr"}},[_vm._l((_vm.sections),function(section,index){return [(_vm.$slots[section.name])?_c('section',{key:index,style:(section.style)},[_vm._t(section.name)],2):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }